/*
 * Copyright (c) 2021 Adres.
 * All rights reserved.
 */

import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

import { SuccessScreenV2 } from 'aurora-section-components';
import { applicationActions } from 'aurora-utils/constants';

function Layout(props) {
  const { history, type, title, subTitle, data, downloadhandler, isShowPdfButton, downloadPaymentHandler } = props;

  const applicationAction = useMemo(() => {
    if (type === 'rejection') {
      return applicationActions.reject;
    }
    if (type === 'termination') {
      return applicationActions.terminate;
    }

    return applicationActions.success;
  }, [type]);

  const downloadCertificatesList = useMemo(() => {
    return [
      ...(isShowPdfButton === true
        ? [
            {
              title: 'Download_contract',
              primary: true,
              downloadHandler: downloadhandler,
            },
          ]
        : []),
      ...(typeof downloadPaymentHandler === 'function'
        ? [
            {
              title: 'download_payment_receipt',
              primary: false,
              downloadHandler: downloadPaymentHandler,
            },
          ]
        : []),
    ];
  }, [isShowPdfButton, downloadhandler, downloadPaymentHandler]);

  return (
    <SuccessScreenV2
      title={title}
      subTitle={subTitle}
      applicationNumber={data?.en?.application?.applicationDetails?.applicationNumber}
      applicationAction={applicationAction}
      downloadCertificatesList={downloadCertificatesList}
      submissionButtonContent='go_to_applications'
      submissionHandler={() => history.push('/app/applications')}
    />
  );
}

Layout.propTypes = {
  history: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.string.isRequired,
  data: PropTypes.object.isRequired,
  isShowPdfButton: PropTypes.bool.isRequired,
  downloadhandler: PropTypes.func.isRequired,
  downloadPaymentHandler: PropTypes.func,
};
Layout.defaultProps = {
  downloadPaymentHandler: null,
};

export default Layout;
